var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.02891 18 0 13.9711 0 9C0 4.02891 4.02891 0 9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18ZM10.8 15.975C12.1957 15.6129 13.4473 14.843 14.4 13.7602V8.1C13.4051 8.1 12.6 7.29492 12.6 6.3V2.76328C11.7703 2.28516 10.8492 1.9793 9.9 1.86328V2.7C9.9 3.69492 9.09492 4.5 8.1 4.5V5.4C8.1 6.39492 7.29492 7.2 6.3 7.2V9H9C9.99492 9 10.8 9.80508 10.8 10.8V15.975ZM7.2 15.975V13.5C6.20508 13.5 5.4 12.6949 5.4 11.7V10.8H4.95C4.20469 10.8 3.6 10.1953 3.6 9.45V7.2H2.025C1.03359 11.0531 3.35039 14.9766 7.2 15.975Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d10e241a.svg";
export { ForwardRef as ReactComponent };